// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"114":"core","184":"routines","472":"settings","736":"competition"}[chunkId] + "." + {"114":"0b1592e8","184":"bb63f7ca","472":"0b1592e8","736":"3ea7ef0e"}[chunkId] + ".chunk.css";
};